import React from 'react'
import styled, { ITheme } from '../../../../../../theme'
import { IWithSize } from '../../../../../BookingCalendar/Calendar/Calendar'

const Background = styled.div<{ empty?: boolean } & IWithSize>`
  width: ${({ size }) => (size ? 20 * size : 20)}px;
  height: ${({ size }) => (size ? 15 * size : 15)}px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  color: white;
  font-size: ${({ size }) => (size ? 12 * size : 12)}px;
  letter-spacing: 0.12px;
  background-color: ${(props: ITheme & { empty: boolean }) =>
    props.empty
      ? props.theme.colors.palette.kelleyGreen
      : props.theme.colors.palette.darkGreyTwo};
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    background-color: ${(props: ITheme & { empty: boolean }) =>
      props.empty
        ? props.theme.colors.palette.darkGreyTwo
        : props.theme.colors.palette.emerald};
  }
`

function NotificationBadge({ taskCount, size = 1 }: INotificationBadgeProps) {
  const count = Number(taskCount) > 9 ? '9+' : taskCount

  return (
    <Background size={size} empty={taskCount === '0'}>
      {count}
    </Background>
  )
}

export default NotificationBadge

export interface INotificationBadgeProps {
  taskCount?: string
  size?: number
}
